import { createSteeringURL } from '@/api'
import { steeringAuthInit } from '@/stores/auth'
import { useMediaCascade } from '@/stores/media'
import { Episode, EpisodeCreateData, EpisodeUpdateData } from '@/types'
import { aggregateWithIdsParameter, useStoreHelpers } from '@/util/api'
import {
  APICreate,
  APIListPaginated,
  APIRemove,
  APIRetrieve,
  APIUpdate,
  createExtendableAPI,
} from '@rokoli/bnb/drf'
import { defineStore } from 'pinia'
import { MaybeRefOrGetter, toValue } from 'vue'

export const useEpisodeStore = defineStore('episodes', () => {
  const endpoint = createSteeringURL.prefix('episodes')
  const { api, base } = createExtendableAPI<Episode>(endpoint, steeringAuthInit)
  const listOperations = APIListPaginated(api)
  const retrieveOperations = APIRetrieve(api, {
    aggregate: aggregateWithIdsParameter(listOperations.listIsolated),
  })
  return {
    ...base,
    ...listOperations,
    ...retrieveOperations,
    ...APICreate<Episode, EpisodeCreateData>(api),
    ...APIUpdate<Episode, EpisodeUpdateData>(api),
    ...APIRemove(api),
    ...useStoreHelpers({ ...base, ...listOperations, ...retrieveOperations }),
  }
})

export function useEpisodeMediaCascade(episode: MaybeRefOrGetter<Episode | null>) {
  return useMediaCascade(() => toValue(episode)?.resolvedMedia ?? null)
}
